import React, { useEffect } from 'react';
import { Col, Row } from 'antd';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { useNavigate } from 'react-router-dom';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { FeedProductionsTable } from '@app/components/apps/FeedProduction/FeedProductionTable';

const AllFeedProductions: React.FC = () => {
  const { setBreadcrumb, addHeaderButton, clearHeaderButtons } = useHeader();
  const navigate = useNavigate();

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumb
        routes={[{ path: `/feed-productions`, breadcrumbName: `Feed Productions` }]}
        style={{ marginBottom: '15px' }}
      />,
    );

    addHeaderButton(
      'Register Product',
      <BaseButton type="primary" size="small" onClick={() => navigate('/add-feed-productions')}>
        Add
      </BaseButton>,
    );

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, addHeaderButton, clearHeaderButtons, navigate]);

  return (
    <>
      <PageTitle>Feed Productions</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <FeedProductionsTable />
        </Col>
      </Row>
    </>
  );
};

export default AllFeedProductions;
